module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg1@3x.981b5b49.png";